import {createContext, useEffect, useReducer} from "react";
import {globalReducer} from "./globalReducer";
import {setDialog, setSnackbar, setUser} from "./globalAction";
import {dialogTypes, snackbarTypes} from "./globalVariables";

const user = localStorage.getItem('user') || null;
export const GlobalDataDefault = {
    snackbar: {
        snackbar: {
            message: "Loading...",
            type: snackbarTypes.loading,
            show: false,
            autoClose: true,
        }
    },
    user: user,
    dialog: dialogTypes.none

}

export const GlobalContext = createContext<any>({
    state: GlobalDataDefault,
    dispatchGlobalData: () => {
    }
});

const GlobalContextProvider = (props: any) => {
    const [globalData, dispatchGlobalData] = useReducer(globalReducer, GlobalDataDefault)

    useEffect(() => {
        dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message: "Loading...",
                    type: snackbarTypes.loading,
                    show: false,
                    autoClose: true,
                }
            }
        });

        dispatchGlobalData({
            type: setUser,
            payload: {
                user: user ? JSON.parse(user) : null
            }
        });

        dispatchGlobalData({
            type: setDialog,
            payload: {
                dialog: dialogTypes.none
            }
        });
    }, []);

    return (
        <GlobalContext.Provider value={{globalData, dispatchGlobalData}}>
            {props.children}
        </GlobalContext.Provider>
    )
}

export default GlobalContextProvider;
